import Vue from 'vue'
import HomeIcon from 'vue-material-design-icons/Home.vue'
import NewspaperVariantOutlineIcon from 'vue-material-design-icons/NewspaperVariantOutline.vue'
import CellphoneBasicIcon from 'vue-material-design-icons/CellphoneBasic.vue'
import TrashCanOutlineIcon from 'vue-material-design-icons/TrashCanOutline.vue'
import AccountMultiplePlusOutlineIcon from 'vue-material-design-icons/AccountMultiplePlusOutline.vue'
import CreditCardOutlineIcon from 'vue-material-design-icons/CreditCardOutline.vue'
import HandClapIcon from 'vue-material-design-icons/HandClap.vue'
import PartyPopperIcon from 'vue-material-design-icons/PartyPopper.vue'
import AlertCircleOutlineIcon from 'vue-material-design-icons/AlertCircleOutline.vue'
import AccountCheckOutlineIcon from 'vue-material-design-icons/AccountCheckOutline.vue'
import AccountPlusOutlineIcon from 'vue-material-design-icons/AccountPlusOutline.vue'
import AccountEditOutlineIcon from 'vue-material-design-icons/AccountEditOutline.vue'
import AccountArrowRightOutlineIcon from 'vue-material-design-icons/AccountArrowRightOutline.vue'
import AlertBoxOutlineIcon from 'vue-material-design-icons/AlertBoxOutline.vue'
import CheckIcon from 'vue-material-design-icons/Check.vue'
import DockWindowIcon from 'vue-material-design-icons/DockWindow.vue'
import ArrowRightBoldIcon from 'vue-material-design-icons/ArrowRightBold.vue'
import LogoutIcon from 'vue-material-design-icons/Logout.vue'
import CalendarMultiselectOutlineIcon from 'vue-material-design-icons/CalendarMultiselectOutline.vue'
import MagnifyIcon from 'vue-material-design-icons/Magnify.vue'
import CurrencyUsdIcon from 'vue-material-design-icons/CurrencyUsd.vue'
import FinanceIcon from 'vue-material-design-icons/Finance.vue'
import FireCircleIcon from 'vue-material-design-icons/FireCircle.vue'
import FireIcon from 'vue-material-design-icons/Fire.vue'
import DotsHorizontalIcon from 'vue-material-design-icons/DotsHorizontal.vue'
import DotsVerticalIcon from 'vue-material-design-icons/DotsVertical.vue'
import PlusCircleOutlineIcon from 'vue-material-design-icons/PlusCircleOutline.vue'
import InformationVariantIcon from 'vue-material-design-icons/InformationVariant.vue'
import ElevatorUpIcon from 'vue-material-design-icons/ElevatorUp.vue'
import ElevatorDownIcon from 'vue-material-design-icons/ElevatorDown.vue'
import GoldIcon from 'vue-material-design-icons/Gold.vue'
import MemoryIcon from 'vue-material-design-icons/Memory.vue'
import BankIcon from 'vue-material-design-icons/Bank.vue'

Vue.component('HomeIcon', HomeIcon)
Vue.component('NewspaperVariantOutlineIcon', NewspaperVariantOutlineIcon)
Vue.component('CellphoneBasicIcon', CellphoneBasicIcon)
Vue.component('TrashCanOutlineIcon', TrashCanOutlineIcon)
Vue.component('AccountMultiplePlusOutlineIcon', AccountMultiplePlusOutlineIcon)
Vue.component('CreditCardOutlineIcon', CreditCardOutlineIcon)
Vue.component('HandClapIcon', HandClapIcon)
Vue.component('PartyPopperIcon', PartyPopperIcon)
Vue.component('AlertCircleOutlineIcon', AlertCircleOutlineIcon)
Vue.component('AccountCheckOutlineIcon', AccountCheckOutlineIcon)
Vue.component('AccountPlusOutlineIcon', AccountPlusOutlineIcon)
Vue.component('AccountEditOutlineIcon', AccountEditOutlineIcon)
Vue.component('AccountArrowRightOutlineIcon', AccountArrowRightOutlineIcon)
Vue.component('AlertBoxOutlineIcon', AlertBoxOutlineIcon)
Vue.component('CheckIcon', CheckIcon)
Vue.component('DockWindowIcon', DockWindowIcon)
Vue.component('ArrowRightBoldIcon', ArrowRightBoldIcon)
Vue.component('LogoutIcon', LogoutIcon)
Vue.component('CalendarMultiselectOutlineIcon', CalendarMultiselectOutlineIcon)
Vue.component('MagnifyIcon', MagnifyIcon)
Vue.component('CurrencyUsdIcon', CurrencyUsdIcon)
Vue.component('FinanceIcon', FinanceIcon)
Vue.component('FireCircleIcon', FireCircleIcon)
Vue.component('FireIcon', FireIcon)
Vue.component('DotsHorizontalIcon', DotsHorizontalIcon)
Vue.component('DotsVerticalIcon', DotsVerticalIcon)
Vue.component('PlusCircleOutlineIcon', PlusCircleOutlineIcon)
Vue.component('InformationVariantIcon', InformationVariantIcon)
Vue.component('ElevatorUpIcon', ElevatorUpIcon)
Vue.component('ElevatorDownIcon', ElevatorDownIcon)
Vue.component('GoldIcon', GoldIcon)
Vue.component('MemoryIcon', MemoryIcon)
Vue.component('BankIcon', BankIcon)
